import { DocumentStatus } from '../models';
import { getStatusLabel } from '../utils';

export type DocumentStatusLabelProps = {
  status: DocumentStatus;
};

export const DocumentStatusLabel = ({ status }: DocumentStatusLabelProps) => (
  <>{getStatusLabel(status)}</>
);
